import { takeLatest } from "redux-saga/effects";
import getClientsListForVendorWorker from "./getClientsListForVendorWorker";
import getServicesListWorker from "./getServicesListWorker";

export function* dashboardWatcher() {
    yield takeLatest("dashboard/getActiveServicesListFetch", getServicesListWorker);
    yield takeLatest("dashboard/getClientsListForVendorFetch", getClientsListForVendorWorker);
}